// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaO = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M6.836 11.988c0-3.052 1.988-5.236 5.026-5.236s5.054 2.17 5.054 5.236c0 3.038-1.946 5.208-5.04 5.208-3.08 0-5.04-2.17-5.04-5.208m8.246-.014c0-2.17-1.218-3.724-3.234-3.724-2.002 0-3.206 1.582-3.206 3.71 0 2.142 1.218 3.738 3.22 3.738s3.22-1.582 3.22-3.724"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaO;
